<template>
    <div class="HotelList">
        <van-sticky>
            <div class="search-wrap jc-between ai-center">
                <van-icon @click="$back()" class="back-wrap" size="20" name="arrow-left" />
                <div class="searchBox jc-between ai-center mr-5">
                    <div class="search-left flex-column flex-center" @click="showDataPopup = !showDataPopup">
                        <div class="timeItem">
                            <span>住</span>
                            <span>{{ routeQuery.startTime | formatDate1 }}</span>
                        </div>
                        <div class="timeItem">
                            <span>离</span>
                            <span>{{ routeQuery.endTime | formatDate1 }}</span>
                        </div>
                    </div>
                    <div class="search-right jc-between ai-center flex-1">
                        <van-search @search="searchHotel" v-model="routeQuery.selectedKeyword" placeholder="请输入关键词" />
                    </div>
                </div>
            </div>
        </van-sticky>
        <van-dropdown-menu>
            <van-dropdown-item :title="routeQuery.selectedAreaObj.name" ref="cityPicker">
                <van-area :value="routeQuery.selectedAreaObj.code" :area-list="areaList" @cancel="$refs.cityPicker.toggle()" @confirm="confirmArea" />
            </van-dropdown-item>
            <!-- <van-dropdown-item @change="confirmStars" v-model="routeQuery.selectedStar.index" :options="option2" /> -->
        </van-dropdown-menu>
        <div class="list-wrap" id="list-wrap">
            <lazy-list ref="hotelLL" :api="getAllHotel" :params="searchObj">
                <template #default="{list}">
                    <hotel-item
                        v-for="(item, index) in list"
                        :key="index"
                        @click="clickHotelItem(item.id)"
                        :cover="$getImageUrl(item.hotelImages.split(',')[0])"
                        :title="item.hotelName"
                        :type="item.stars"
                        :location="item.hotelAddress"
                    />
                </template>
            </lazy-list>
        </div>
        <to-top listId="list-wrap" />
        <van-popup v-model="showDataPopup" class="datePopup flex-center" position="top" :style="{ height: '22%' }">
            <div class="width-100">
                <van-cell is-link :value="dataLength" class="selectDate-wrap">
                    <template #title>
                        <div class="jc-between">
                            <div class="dateItem clickOuterActive" @click="clickDate('start')">
                                <div>入住日期</div>
                                <div>
                                    <span>{{ routeQuery.startTime | formatDate2 }}</span>
                                    <span>周{{ routeQuery.startTime | formatWeek }}</span>
                                </div>
                            </div>
                            <div class="dateItem clickOuterActive" @click="clickDate('end')">
                                <div>离店日期</div>
                                <div>
                                    <span>{{ routeQuery.endTime | formatDate2 }}</span>
                                    <span>周二</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </van-cell>
                <van-button class="orderBtn" @click="showDataPopup = false" color="linear-gradient(90deg,#fde59f,#ebb06c)" block>
                    完成
                </van-button>
            </div>
        </van-popup>
        <van-popup v-model="showDatePicker" round position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                @cancel="showDatePicker = false"
                @confirm="confirmDate"
                type="date"
                :title="`${dateType == 'start' ? '请选择入住时间' : '请选择离店日期'}`"
                :min-date="minDate"
                :max-date="maxDate"
            />
        </van-popup>
    </div>
</template>
<script>
import areaList from "@/utils/area.js";
import { searchParamsKey } from "@/utils/variable";
import { Toast } from "vant";
import { getAllHotel } from "@/api/hotel";
const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).getTime();
let initRouteQuery = {
    startTime: today,
    endTime: today + 1000 * 60 * 60 * 24,
    selectedStar: {
        index: -1,
        title: "星级/价格",
    },
    selectedAreaObj: {
        code: null,
        name: "请选择城市",
    },
    selectedKeyword: "",
    fuzzySearch: "",
};
export default {
    data() {
        return {
            areaList,
            value2: -1,
            option2: [
                { text: "所有星级", value: -1 },
                { text: "经济型", value: 0 },
                { text: "舒适/三星", value: 1 },
                { text: "高档/四星", value: 2 },
                { text: "豪华/五星", value: 3 },
            ],
            routeQuery: JSON.parse(JSON.stringify(initRouteQuery)),
            showDataPopup: false,
            minDate: new Date(today),
            maxDate: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365),
            showDatePicker: false,
            dateType: "start",
            currentDate: new Date(today),
            canLoad: true,
            pageSize: 10,
            page: 1,
            searchObj: {},
        };
    },
    created() {},
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.routeQuery = localStorage[searchParamsKey] ? JSON.parse(localStorage[searchParamsKey]) : JSON.parse(JSON.stringify(initRouteQuery));
            let routeQuery = vm.routeQuery;
            if (from.path == "/home") {
                vm.searchObj = {
                    isLike: routeQuery.fuzzySearch || "",
                    cityCode: routeQuery.selectedAreaObj.code || "",
                    // stars: routeQuery.selectedStar.index == -1 ? "" : routeQuery.selectedStar.index,
                };
            } else {
                vm.searchObj = {
                    isLike: "",
                    keywords: routeQuery.selectedKeyword || "",
                    cityCode: routeQuery.selectedAreaObj.code || "",
                    // stars: routeQuery.selectedStar.index == -1 ? "" : routeQuery.selectedStar.index,
                };
            }
        });
    },
    watch: {
        "routeQuery.selectedStar.index": {
            handler(newV) {
                let findItem = this.option2.find(item => item.value == newV);
                this.routeQuery.selectedStar = {
                    title: findItem.text,
                    index: findItem.value,
                };
            },
        },
    },
    filters: {
        formatDate1(date) {
            date = new Date(date);
            return `${String(date.getMonth() + 1).padStart(2, "0")}.${String(date.getDate()).padStart(2, "0")}`;
        },
        formatDate2(date) {
            date = new Date(date).toLocaleDateString();
            let arr = date.split("/");
            return `${arr[1]}月${arr[2]}日`;
        },
        formatWeek(week) {
            week = new Date(week).getDay();
            let weeks = ["一", "二", "三", "四", "五", "六", "日"];
            if (week >= 1 && week <= 7) {
                return weeks[week - 1];
            } else {
                return weeks[0];
            }
        },
    },
    computed: {
        dataLength() {
            return `共${Math.floor(
                (new Date(this.routeQuery.endTime).getTime() - new Date(this.routeQuery.startTime).getTime()) / (1000 * 60 * 60 * 24)
            )}晚`;
        },
    },
    methods: {
        getAllHotel,
        searchHotel(val) {
            this.searchObj = {
                ...this.searchObj,
                keywords: val,
                isLike: "",
            };
            this.$nextTick(() => {
                this.$refs.hotelLL.initList();
            });
        },
        clickHotelItem(id) {
            localStorage[searchParamsKey] = JSON.stringify(this.routeQuery);
            this.$router.push({ path: "/hotelDetail", query: { id } });
        },
        clickDate(type) {
            this.showDatePicker = true;
            this.dateType = type;
            if (type == "start") {
                this.currentDate = new Date(this.routeQuery.startTime);
            } else {
                this.currentDate = new Date(this.routeQuery.endTime);
            }
        },
        confirmDate(e) {
            let DateTime = e.getTime();
            if (this.dateType == "start") {
                if (this.routeQuery.endTime - DateTime >= 1000 * 60 * 60 * 24) {
                    this.routeQuery.startTime = DateTime;
                } else {
                    return Toast("开始时间应小于结束时间");
                }
            } else {
                if (DateTime - this.routeQuery.startTime >= 1000 * 60 * 60 * 24) {
                    this.routeQuery.endTime = DateTime;
                } else {
                    return Toast("结束时间应大于开始时间");
                }
            }
            this.showDatePicker = false;
        },
        confirmArea(e) {
            this.routeQuery.selectedAreaObj = e[2];
            this.$refs.cityPicker.toggle();
            this.searchObj = {
                ...this.searchObj,
                cityCode: e[2].code,
                isLike: "",
            };
            this.$refs.hotelLL.initList();
        },
        confirmStars(stars) {
            if (stars == -1) {
                this.searchObj = {
                    ...this.searchObj,
                    isLike: "",
                    stars: "",
                };
            } else {
                this.searchObj = {
                    ...this.searchObj,
                    isLike: "",
                    stars,
                };
            }
            this.$nextTick(() => {
                this.$refs.hotelLL.initList();
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.HotelList {
    .search-wrap {
        padding: 2vw 0;
        position: relative;
        z-index: 9999;
        background-color: #fff;
        .back-wrap {
            padding: 2vw;
            margin: 0 2.2vw;
        }
        .searchBox {
            flex: 1;
            box-shadow: 0 0 4px #ccc;
            font-size: 3vw;
            border-radius: 1.5vw;
            overflow: hidden;
            background-color: #f2f2f2;
            .search-left {
                padding: 0 2.5vw;
                border-right: 1px solid #ccc;
                &:active {
                    background: rgba($color: #ccc, $alpha: 0.3);
                }
                .timeItem {
                    > span:first-child {
                        margin-right: 1.5vw;
                    }
                    > span:last-child {
                        color: #cdab6d;
                    }
                }
            }
            .search-right {
                input {
                    width: 0;
                    height: 8vw;
                    font-size: 3.8vw;
                    border: none;
                    outline: none;
                }
                /deep/.van-search {
                    flex: 1;
                    padding: 1vw 0;
                    background-color: transparent;
                    * {
                        font-size: 3.8vw;
                    }
                    .van-icon-search {
                        font-size: 5vw;
                    }
                }
                /deep/.van-search__content {
                    background-color: inherit;
                    padding-left: 0;
                }
                /deep/.van-cell {
                    padding: 1.2vw 2vw;
                    display: flex;
                    align-items: center;
                }
            }
        }
        .searchBtn {
            margin: 0 3.5vw 0;
        }
    }
    /deep/.van-dropdown-menu__bar {
        height: 32px;
    }
    /deep/.van-cell {
        padding: 6px 16px;
    }
    /deep/.van-dropdown-menu__title--active {
        color: $primary;
    }
    /deep/.van-dropdown-item__option--active {
        color: $primary;
        .van-dropdown-item__icon {
            color: $primary;
        }
    }
    .datePopup {
        top: 13vw;
        > div {
            padding: 2vw 3vw;
            box-sizing: border-box;
        }
        .selectDate-wrap {
            align-items: center;
            justify-content: space-between;
            /deep/.van-cell__title {
                flex: 3;
            }
            /deep/.van-cell__value {
                color: #333;
            }
            &:active {
                background-color: #fff;
            }
            .dateItem {
                font-size: 2.8vw;
                > div:last-child {
                    > span:first-child {
                        font-size: 4.4vw;
                        margin-right: 2vw;
                    }
                }
            }
        }
        .orderBtn {
            width: 94%;
            margin: 6vw 3% 0;
            border-radius: 6vw;
        }
    }
    .list-wrap {
        overflow-y: scroll;
        background-color: #f2f2f2;
        width: 100vw;
        height: calc(100vh - 14vw - 32px);
        padding: 3vw;
        box-sizing: border-box;
    }
}
</style>
